import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/paket-kategori";

export default {
  get(payload) {
    const params = {
      page: payload.page || 1,
      page_size: payload.page_size || 10,
      search: payload.search || "",
    };

    if (payload.kategori) {
      params.filters = `kategori:${payload.kategori}`;
    }

    return Client.get(resource, { params });
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },
};
